<template>
  <div>
    <div class="map-page" id="chart-map-demo">
    </div>
  </div>
</template>

<script>
window.echarts = require('echarts')
window.myDemoChat = null

export default {
  data () {
    return {
      loadJs: false,
      first: '0'
    }
  },
  created () {
    this.$store.dispatch('setDemoChatStatus', 0)
  },
  mounted () {
    window.initMapDemo = this.initChar
    let chat = window.echarts.init(document.getElementById('chart-map-demo'))
    window.myDemoChat = chat
    this.$store.dispatch('setDemoChatStatus', 1)
    this.loadBdmapApi()
  },
  methods: {
    loadBdmapApi () {
      this.loadJs = true
      let script = document.createElement('script')
      script.src = 'https://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMapDemo'
      document.body.appendChild(script)
    },
    initChar () {
      this.$store.dispatch('initDemoMapOption')
    }
  }
}
</script>
<style lang="less">
.anchorBL {
  display: none;
}
.map-select-week .el-input__inner{
  text-align: center;
  background-color: #f8ac59;
  color:#fff;
  height: 20px;
  font-size: 10px;
  border:  1px solid #f8ac59;
}
.map-select-week .el-input.is-disabled .el-input__inner {
  background-color: #f8ac59;
  border:  1px solid #f8ac59;
  color:#fff;
}
.map-select-week .el-select .el-input__inner:focus {
  border-color: #f8ac59;
}
.map-select-week .el-select .el-input.is-disabled .el-input__inner:focus {
  border-color: #f8ac59;
}
.map-select-week .el-select:hover .el-input__inner {
  border-color: #f8ac59;
}
.map-select-week .el-select:hover .el-input.is-disabled .el-input__inner {
  border-color: #f8ac59;
}
.map-select-week input::-webkit-input-placeholder {
  color: #eee;
}

</style>
<style scoped lang="less">
.map-page {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// demo_map.vue?7b7d1c0c